import {
  IM_PRICELIST_CASE_DEFAULT_WAITING_ON_OPTIONS,
  ProductModule,
  type WaitingOnOption,
} from '@erp/shared-types';
import {
  useWaitingOnOptions,
  type WaitingOnOptionsSource,
} from '@/components/common/waiting-on/useWaitingOnOptions';

/**
 * Pricelist update cases' binding into the shared waiting-on machinery: the
 * Set Next Step reasons live at
 * `inventoryManagement.pricelistCases.waitingOnOptions` on the Inventory
 * Management module config and fall back to the seeded IM taxonomy.
 *
 * Mirrors `PRICELIST_CASE_WAITING_ON_SOURCE` on the backend, which validates
 * a submitted key against the same list — one config path, so the picker and
 * the server can never disagree about what exists.
 */
export const PRICELIST_CASE_WAITING_ON_SOURCE: WaitingOnOptionsSource = {
  module: ProductModule.INVENTORY_MANAGEMENT,
  readConfiguredOptions: (config) =>
    config?.inventoryManagement?.pricelistCases?.waitingOnOptions,
  defaultOptions: IM_PRICELIST_CASE_DEFAULT_WAITING_ON_OPTIONS,
};

/**
 * The org's "waiting on" options for pricelist update cases, including
 * disabled ones — a key stored on an old case must keep resolving to its
 * label. Filter on `enabled` when offering a reason for a new park.
 */
export function usePricelistCaseWaitingOnOptions(): WaitingOnOption[] {
  return useWaitingOnOptions(PRICELIST_CASE_WAITING_ON_SOURCE);
}
